export const MODULES_FEATURE_KEY = 'modules';
